import { useAppSelector } from '../../../../../../store/hooks';
import { getAreAppsFiltersVisible } from '../../../../store/selectors/get-are-apps-filters-visible/get-are-apps-filters-visible.selector';

export const useAreAppsFiltersVisible = (): boolean => {
  return useAppSelector(getAreAppsFiltersVisible);
};
